import type { StyleSystemProps } from '@withjoy/joykit';
import { Box, styled } from '@withjoy/joykit';

export const StyledRPCSectionContainer = styled(Box)``;

const rpcSectionContainerStyles: StyleSystemProps = {
  width: '100%',
};

const rpcSectionSkeletonStyles: StyleSystemProps = {
  width: '100%',
  paddingTop: 10,
};

const rpcSectionCarouselStyles: StyleSystemProps = {
  width: '100%',
  paddingTop: 10,
};

export const styles = {
  rpcSectionContainer: rpcSectionContainerStyles,
  rpcSectionSkeleton: rpcSectionSkeletonStyles,
  rpcSectionCarousel: rpcSectionCarouselStyles,
};
